import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import * as PartnerProfile from 'app/entities/PartnerProfile';
import * as Profile from 'app/entities/Profile';
import * as ToastNotification from 'app/entities/ToastNotification';
import PreloadPage from 'app/developer-v3/components/PreloadPage';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import {
  teamMemberSaveError,
  teamMemberSaving,
} from 'app/developer-v3/legacy/selectors';

import TeamPage from './TeamPage';

const mapStateToProps = state => {
  const { selectors: notificationSelectors } = ToastNotification;
  const entity = notificationSelectors.all.entities(state)[0];
  const partnerProfile = PartnerProfile.selectors.all.first(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return {
    currentUrl: RouterSelectors.currentUrl(state) || '',
    error: teamMemberSaveError(state),
    hasPartnerRoles: PartnerProfile.selectors.hasPartnerRoles(partnerProfile),
    hasPartnerProfile: PartnerProfile.selectors.hasPartnerProfile(
      partnerProfile
    ),
    isAdminMasqueraded: Profile.selectors.all.isMasquerading(state),
    isDeveloper: Profile.selectors.isDeveloper(currentProfile),
    isLoadingPartnerProfile: PartnerProfile.selectors.all.isLoading(state),
    isSaving: teamMemberSaving(state),
    notification: entity && {
      message: notificationSelectors.message(entity),
      type: notificationSelectors.type(entity),
    },
    termsAccepted: Profile.selectors.hasAcceptedTerms(currentProfile),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoad() {
      dispatch([PartnerProfile.actions.loadCollection()]);
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent, { LoadingComponent: PreloadPage })(TeamPage));
